import React from 'react';

import FLAG_ICONS from './icons';

const FLAG_ICONS_DICTIONARY = {
  ru: FLAG_ICONS.FlagIconRu,
  es: FLAG_ICONS.FlagIconEs,
  de: FLAG_ICONS.FlagIconDe,
  pl: FLAG_ICONS.FlagIconPl,
  tr: FLAG_ICONS.FlagIconTr,
  kz: FLAG_ICONS.FlagIconKz,
  'ru-kz': FLAG_ICONS.FlagIconKz,
  'ru-ua': FLAG_ICONS.FlagIconUa,
  'ru-by': FLAG_ICONS.FlagIconBy,
  'uk-ua': FLAG_ICONS.FlagIconUa,
  'en-gb': FLAG_ICONS.FlagIconUk,
  'en-us': FLAG_ICONS.FlagIconUs,
  'en-ie': FLAG_ICONS.FlagIconIe,
  fr: FLAG_ICONS.FlagIconFr,
  'ru-us': FLAG_ICONS.FlagIconRu,
  'ru-uz': FLAG_ICONS.FlagIconUz,
};

function FlagsIcon({ lang, ...iconParams }) {
  const FlagIcon = FLAG_ICONS_DICTIONARY[lang] || FLAG_ICONS.FlagIconRu;

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <FlagIcon {...iconParams} />;
}

FlagsIcon.defaultProps = {
  w: 20,
  h: 20,
  style: {},
  fill: '#000',
};

export default FlagsIcon;
